import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

import { mockPipelineData } from '../how-to-setup-pipeline/mockData';

const useGetHowToSetupStage = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep, setMeta } = useTour();

  const isCollapsed = state?.collapse;
  const setupStageSteps: StepType[] = [
    {
      content: 'Go to the Sales Menu Tab',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.MENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 500);
          },
          false,
        );
      },
    },
    {
      content: 'Then select Deals to view the Deals page.',
      position: 'right',
      padding: { popover: [0, 0, 0, 30] },
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 500);
          },
          false,
        );
      },
    },
    {
      content:
        // eslint-disable-next-line max-len
        'Select the Gear icon next to the Create Deal button, and you will be directed to the Sales Deal Settings page.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.SETTINGS_BUTTON}"]`,
      padding: { popover: [-30, -35] },
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => {
              setMeta?.(JSON.stringify(mockPipelineData[0]));
              setCurrentStep(3);
            }, 1000);
          },
          false,
        );
      },
    },
    {
      content: 'Click on the three dots next to your desired pipeline',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.PIPELINE.MANAGE.THREE_DOTS_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 1000);
          },
          false,
        );
      },
    },
    {
      content: 'Select Configure Pipeline.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.PIPELINE.MANAGE.CONFIGURE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setMeta?.(JSON.stringify(mockPipelineData[0]));
            setTimeout(() => setCurrentStep(5), 500);
          },
          false,
        );
      },
    },
    {
      content:
        'Add a new stage to the pipeline by clicking on the Add button at the top.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.NEW_TILE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(6), 500);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          type="Stage Name"
          content="Add a new stage name to the pipeline by clicking on the Add button at the top"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.NEW_TILE_FORM}"]`,
      stepInteraction: false,
    },
    {
      content: 'Click the check button to save and you are done',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.NEW_TILE_SAVE}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(8), 500);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          content="You can view your created stage here."
          {...props}
          endTour
        />
      ),
      selector: `[data-rbd-droppable-id="stageSettings"]`,
      stepInteraction: false,
      actionAfter: () => {
        window.location.href = '/';
      },
    },
  ];

  const showSetupStage = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }
    setTimeout(() => {
      setSteps?.(setupStageSteps);
      setIsOpen(true);
    }, 300);
  };

  return showSetupStage;
};

export default useGetHowToSetupStage;
